/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser'

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    // clientId: "Enter_the_Application_Id_Here",
    // authority: "Enter_the_Cloud_Instance_Id_HereEnter_the_Tenant_Info_Here",
    clientId: '0c7005cc-d80c-403e-ae40-14f01cc9088b',
    authority: 'https://login.microsoftonline.com/common',
    // authority: "https://login.microsoftonline.com/achrafchad.onmicrosoft.com",
    //             https://login.microsoftonline.com/ca66d5e6-4c14-4ada-8702-03817c8d7df1/saml2
    redirectUri: 'https://insightsassistant.mavenmagnet.com/authorize-azure',

    // clientId: "f2b587d6-a8fd-481f-a010-95b83422248a",
    // redirectUri: "http://localhost:8080/authorize-azure"
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    // loggerOptions: {
    //     loggerCallback: (level, message, containsPii) => {
    //         if (containsPii) {
    //             return;
    //         }
    //         switch (level) {
    //             case LogLevel.Error:
    //                 console.error(message);
    //                 return;
    //             case LogLevel.Info:
    //                 console.info(message);
    //                 return;
    //             case LogLevel.Verbose:
    //                 console.debug(message);
    //                 return;
    //             case LogLevel.Warning:
    //                 console.warn(message);
    //                 return;
    //             default:
    //                 return;
    //         }
    //     }
    // }
  },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'Enter_the_Graph_Endpoint_Herev1.0/me', //e.g. https://graph.microsoft.com/v1.0/me
}
